//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import { VMenu, VDatePicker, VInput } from 'vuetify/lib';
import NsTextField from './NsTextField.vue';
export default {
  components: {
    NsTextField,
    VMenu,
    VDatePicker,
    VInput,
  },
  props: {
    /**
     * Formats the date using momentJS. It will support all formats that momentJS supports.
     */
    dateFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    /**
     * Sets the max-width of the component
     */
    width: {
      type: [Number, String],
      default: 290,
    },
    /**
     * Sets the locale. It will suppor the Vuetify format of locales
     */
    locale: {
      type: String,
      default: 'en-US',
    },
    /**
     * Sets the first day of the week. 0 for Sunday and 1 for Monday.
     */
    firstDayOfWeek: {
      type: Number,
      default: 0,
    },
    /**
     * Sets the color. this accepts hex codes only.
     */
    color: {
      type: String,
      default: '#94D6E9',
    },
    /**
     * Sets the label for the text input
     */
    label: {
      type: String,
      default: null,
    },
    /**
     * Adds a 'x' icon to the text input.
     */
    clearable: Boolean,
    /**
     * The value  of the input
     */
    value: {
      type: String,
      default: null,
    },
    /**
     * Minimum date ie can not select dates before this date.
     */
    min: {
      type: String,
      default: '1900-01-01',
    },
    /**
     * Maximum date ie can not select dates after this date.
     */
    max: {
      type: String,
      default: undefined,
    },
    /**
     * Type is either 'date' or 'month'
     */
    type: {
      type: String,
      default: 'date',
    },
    /**  Birthdate option shows a picker designed for birthday dates and not future dates */
    birthdate: {
      type: Boolean,
      default: false,
    },
    /** Required field is optional */
    required: {
      type: Boolean,
      default: false,
    },
    /** When required is set to true this message will show underneath the date field */
    requiredErrorMessage: {
      type: String,
      default: 'This field is required',
    },
  },
  data() {
    return {
      /**
       * PickerDate is the value of the input
       */
      pickerDate: this.birthdate
        ? null
        : this.value != null
        ? this.value
        : new Date().toISOString().substr(0, 10),
      /**
       * If true shows the calendar
       */
      showMenu: false,
      rules: [(v) => Boolean(v) || !this.required || this.requiredErrorMessage],
    };
  },
  computed: {
    computedDateFormatted() {
      return this.pickerDate
        ? moment(this.pickerDate).locale(this.locale).format(this.dateFormat)
        : '';
    },
    date() {
      return this.value != null ? this.value : this.pickerDate;
    },
    maxDate() {
      return this.birthdate && !this.max
        ? new Date().toISOString().substr(0, 10)
        : this.max;
    },
  },
  watch: {
    /**
     * @event input
     * @type {string}
     */
    pickerDate(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.pickerDate = val;
    },
    showMenu(val) {
      this.$emit('shown', val);
      if (this.birthdate && val) {
        setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
      }
    },
  },
  methods: {
    /**
     * @event clear
     * @type {string}
     */
    handleClear() {
      this.pickerDate = '';
    },
    handleBlur(event) {
      const value = event.target.value;
      if (!value) {
        this.pickerDate = '';
      }
    },
    handlePaste() {
      return false;
    },
    handleKeyDown(event) {
      if (event.key !== 'Tab') {
        event.preventDefault();
      }
    },
    handleKeyUp(event) {
      if (event.key !== 'Escape') {
        this.showMenu = true;
      }
    },
  },
};
